import { Component, EventEmitter, OnChanges } from '@angular/core';
import { DynamicFormComponent } from '@components/dynamic-form/dynamic-form.component';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '@services/admin/user.service';
import { Registry } from '@/registry.service';
import { UtilizzatoreForm } from '@/form-settings/utilizzatore-form';
import { PracticesService } from '@services/practices.service';
import { PracticeModel } from '@/models/practice.model';
import { LoggerService } from '@services/logger.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { RentalClientsService } from '@services/data-source-tables/rentals/rental-clients.service';
import { DialogSelectClientRentComponent } from '@pages/rental-management/rent-practice-detail/rental-movements-list/dialog-form-rental-movement/dialog-select-client-rent/dialog-select-client-rent.component';

@Component({
  selector: 'app-detail-practice-utilizzatore-form',
  templateUrl: '../../../../../components/dynamic-form/dynamic-form.component.html',
  styleUrls: ['../../../../../components/dynamic-form/dynamic-form.component.scss'],
})
export class DetailPracticeUtilizzatoreFormComponent
  extends DynamicFormComponent
  implements OnChanges
{
  protected closeSelectClientEvent$: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    protected toastr: ToastrService,
    protected userService: UserService,
    protected practiceService: PracticesService,
    protected dialogRef: MatDialog,
    protected rentalClientsService: RentalClientsService,
  ) {
    super(toastr, userService);

    this.submitTopButton = false;
    this.submitBottomButton = true;
    this.submitButtonVisible = true;
    this.primaryButton = 'Salva';
    this.thirdButton = 'Seleziona utilizzatore';
    this.setupMeta();

    Registry.getInstance().set('DetailPracticeUtilizzatoreFormComponent', this);
  }

  public ngOnChanges() {
    super.ngOnChanges();

    if (Object.values(this.data).length !== 0) {
      this.setupMeta();
    }
  }

  setupMeta(): void {
    this.meta = UtilizzatoreForm.getMeta();
  }

  public onSubmit() {
    this.submitButtonLoading = true;
    let practice = <PracticeModel>this.form.getRawValue();
    practice = this.setupUtilizzatoreData(practice);

    this.practiceService.savePractice(practice).subscribe({
      next: (response) => {
        this.toastr.success('Dati utilizzatore salvati correttamente!');
        Registry.getInstance().get('PracticeDetailsComponent').data = <PracticeModel>response;

        this.submitButtonLoading = false;
      },
      error: (error) => {
        LoggerService.error('savePractice failed!');
        LoggerService.error(error);
        this.manageErrorMessages(error);
        this.submitButtonLoading = false;
        Registry.getInstance().set('saveInProgress', false);
      },
      complete: () => {
        LoggerService.log('Request done');
      },
    });
  }

  protected manageErrorMessages(error: HttpErrorResponse) {
    if (error.error && error.error.message) {
      this.toastr.error(error.error.message);
    } else {
      this.toastr.error('Si è verificato un errore durante il salvataggio dei dati');
    }
  }

  protected thirdButtonAction() {
    Registry.getInstance().set('closeSelectClientEvent$', this.closeSelectClientEvent$);

    const dialogSelectClient = this.dialogRef.open(DialogSelectClientRentComponent, {
      data: {
        service: this.rentalClientsService,
      },
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    Registry.getInstance()
      .get('closeSelectClientEvent$')
      .subscribe((client) => {
        // Set only the Utilizzatore fields that are present in the Practice model
        this.form.get('bpUtilizzatore').setValue(client.numeroBp);
        this.form.get('denominazioneUtilizzatore').setValue(client.denominazione);
        this.form.get('codiceFiscaleUtilizzatore').setValue(client.codiceFiscale);
        this.form.get('cittaUtilizzatore').setValue(client.localita);
        this.form.get('indirizzoUtilizzatore').setValue(client.indirizzo);
        this.form.get('pivaUtilizzatore').setValue(client.piva);
        this.form.get('emailUtilizzatore').setValue(client.email);
        this.form.get('telefonoUtilizzatore').setValue(client.numeroTelefono);
        this.form.get('patenteUtilizzatore').setValue(client.numeropatente);

        dialogSelectClient.close();
      });
  }

  private setupUtilizzatoreData(practice: PracticeModel) {
    // Preserve all existing practice data
    practice = { ...this.data };

    // Update only the utilizzatore fields with new values
    practice.bpUtilizzatore = this.form.get('bpUtilizzatore')?.value ?? this.data.bpUtilizzatore;
    practice.denominazioneUtilizzatore =
      this.form.get('denominazioneUtilizzatore')?.value ?? this.data.denominazioneUtilizzatore;
    practice.indirizzoUtilizzatore =
      this.form.get('indirizzoUtilizzatore')?.value ?? this.data.indirizzoUtilizzatore;
    practice.cittaUtilizzatore =
      this.form.get('cittaUtilizzatore')?.value ?? this.data.cittaUtilizzatore;
    practice.patenteUtilizzatore =
      this.form.get('patenteUtilizzatore')?.value ?? this.data.patenteUtilizzatore;
    practice.patenteRilasciataDaUtilizzatore =
      this.form.get('patenteRilasciataDaUtilizzatore')?.value ??
      this.data.patenteRilasciataDaUtilizzatore;
    practice.pivaUtilizzatore =
      this.form.get('pivaUtilizzatore')?.value ?? this.data.pivaUtilizzatore;
    practice.codiceFiscaleUtilizzatore =
      this.form.get('codiceFiscaleUtilizzatore')?.value ?? this.data.codiceFiscaleUtilizzatore;
    practice.telefonoUtilizzatore =
      this.form.get('telefonoUtilizzatore')?.value ?? this.data.telefonoUtilizzatore;
    practice.emailUtilizzatore =
      this.form.get('emailUtilizzatore')?.value ?? this.data.emailUtilizzatore;

    return practice;
  }
}
